import { AxiosResponse } from 'axios';

export const getLocationHeader = (headers: AxiosResponse['headers']): string =>
  headers.location || '';

export const isOnboarding = (s: string): boolean =>
  s.match(/Onboarding/i) !== null;
